export default "__VITE_ASSET__qyeQCuoc__"